import styled from "styled-components";
import Variables from "../../assets/styleVariables";

export const ConfirmContainer = styled.div`
  display: ${props => (props.show ? "flex" : "none")};
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: ${props => (props.showUnderOtherConfirms ? "999998" : "999999")};
  max-height: calc(100vh);
  .overlay {
    background-color: rgba(255, 255, 255, 0.5);
    position: fixed;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
  }
  .confirm-box {
    z-index: 99999;
    min-width: 448px;
    min-height: 198px;
    max-height: 95%;
    border-radius: 4px;
    background-color: ${Variables.colors.complementary};
    -webkit-box-shadow: 0 0 12px 0 #cccccc;
    -moz-box-shadow: 0 0 12px 0 #cccccc;
    box-shadow: 0 0 12px 0 #cccccc;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    position: relative;
    .confirm-header {
      height: 72px;
      padding-right: 24px;
      padding-top: 24px;
      box-sizing: border-box;
      i.confirm-icon {
        width: 32px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        &:before {
          margin: 0;
          font-size: 25px;
          color: ${props => {
            switch (props.type) {
              case "danger":
                return `${Variables.colors.red_500}`;
              case "success":
                return `${Variables.colors.green_400}`;
              case "warning":
                return `${Variables.colors.yellow_500}`;
              case "info":
                return `${Variables.colors.primary_vivid}`;
              default:
                return `${Variables.colors.black}`;
            }
          }};
        }
      }
    }
    .confirm-body {
      padding: 0 24px;
      box-sizing: border-box;
      min-height: 73px;
      max-height: calc(100vh - 125px);
      overflow-y: auto;
      .title {
        color: ${Variables.colors.complementary_600};
        font-size: ${Variables.font_sizes.x_small};
        text-align: right;
      }
      .message {
        color: ${Variables.colors.complementary_900};
        font-size: ${Variables.font_sizes.x2_medium};
        line-height: 1.6;
        text-align: right;
        max-width: 380px;
        box-sizing: border-box;
        //word-break: break-all;
      }
      small {
        color: ${Variables.colors.complementary_600};
      }
      .bold {
        font-weight: ${Variables.font_weight.medium};
      }
    }
    .confirm-footer {
      height: 53px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding: 24px;
      box-sizing: border-box;
      //position: absolute;
      //bottom: 0;
      width: 100%;
      div {
        margin-left: 8px;
      }
      &.div:last-child {
        margin-left: 0;
      }
    }
  }
`;
